export default __webpack_public_path__ + "static/media/mongoorg.bc33aa42.png";